import React, { useEffect, useState } from "react";
import "./Winner_Modal.css";
import { Modal } from "react-bootstrap";
import Win_Lottie from "../../../../Animation/Win_Lottie/Win_Lottie";
import Congratulation_Modal from "../Congratulation_Modal/Congratulation_Modal";

function Winner_Modal({ show, onHide, ...props }) {

  const [modalShow, setModalShow] = useState(false);

  useEffect(() => {
    if (show) {
      const timer = setTimeout(() => {
        onHide();            // close Winner modal
        setModalShow(true);  // open congratulation modal
      }, 3000);

      return () => clearTimeout(timer);
    }
  }, [show, onHide]);

  return (
    <>
      <Modal
        {...props}
        show={show}
        onHide={onHide}
        centered
        size="sm"
        backdrop="static"
        className="Winner_Modal Common_modal"
      >
        <Modal.Body>
          <div className="winner_content_holder">
            <div className="img_holder">
              <img
                src="/assets/images/Winner_Modal/bg.png"
                className="bg_img"
                alt="winner"
              />

              <div className="win_lottie_holder">
                <Win_Lottie />
              </div>

              <div className="result_box">
                <span className="number">2</span>
                <span className="result_color win_box"></span>
                <span className="type">Small</span>
              </div>

              <div className="period_text">
                Period: Trx Win 1 Min 123456789012
              </div>

              <div className="amount_box">
                <img
                  src="/assets/images/icons/rupee.png"
                  alt="coin"
                  className="coin_icon"
                />
                <span>8,989</span>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      <Congratulation_Modal
        show={modalShow}
        onHide={() => setModalShow(false)}
      />
    </>
  );
}

export default Winner_Modal;